import { render } from "./VerificationMain.vue?vue&type=template&id=ec8f2fc0"
import script from "./VerificationMain.vue?vue&type=script&lang=js"
export * from "./VerificationMain.vue?vue&type=script&lang=js"
script.render = render

export default script